// Angular imports
import { Injectable } from '@angular/core';

// RxJS imports
import { Observable, forkJoin } from 'rxjs';

// Model
import { AttachmentParameterDto } from '../../_models/attachment-parameter-dto';
import { EmailAttachmentRawDto } from '../../ciramail-module/_models/email-composer/email-attachment-raw-dto';

@Injectable({
    providedIn: 'root'
})
export class FileReaderService {
    readFileToBase64(file: File): Observable<string> {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        return new Observable((observer) => {
            // if success
            fileReader.onload = (ev) => {
                const fileBase64 = (ev.target as any).result as string; // base 64 string
                observer.next(fileBase64);
                observer.complete();
            };
            // if failed
            fileReader.onerror = (error) => {
                observer.error(error);
            };
        });
    }

    readFile(file: File): Observable<AttachmentParameterDto> {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        return new Observable((observer) => {
            // if success
            fileReader.onload = (ev) => {
                const uploadFileInfo = new AttachmentParameterDto();
                uploadFileInfo.fileName = file.name;
                uploadFileInfo.attachmentBase64 = (ev.target as any).result as string; // base 64 string
                observer.next(uploadFileInfo);
                observer.complete();
            };
            // if failed
            fileReader.onerror = (error) => {
                observer.error(error);
            };
        });
    }

    readFiles(files: File[]): Observable<AttachmentParameterDto[]> {
        return forkJoin([...files.map((file) => this.readFile(file))]);
    }

    readAttachmentFile(file: File, attachmentFieldId?: number): Observable<AttachmentParameterDto> {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        return new Observable((observer) => {
            // if success
            fileReader.onload = (ev) => {
                const uploadFileInfo = new AttachmentParameterDto();
                uploadFileInfo.fileName = file.name;
                uploadFileInfo.attachmentBase64 = (ev.target as any).result as string; // base 64 string
                uploadFileInfo['fieldId'] = attachmentFieldId;
                observer.next(uploadFileInfo);
                observer.complete();
            };

            // if failed
            fileReader.onerror = (error) => {
                observer.error(error);
            };
        });
    }

    readAttachmentFiles(files: File[], attachmentFieldId?: number): Observable<AttachmentParameterDto[]> {
        return forkJoin([...files.map((file) => this.readAttachmentFile(file, attachmentFieldId))]);
    }

    readEmailAttachmentFile(file: File): Observable<EmailAttachmentRawDto> {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        return new Observable((observer) => {
            // if success
            fileReader.onload = (ev) => {
                const uploadFileInfo = new EmailAttachmentRawDto();
                uploadFileInfo.fileName = file.name;
                uploadFileInfo.mode = 'LOCAL';
                uploadFileInfo.fileBase64String = (ev.target as any).result as string; // base 64 string
                observer.next(uploadFileInfo);
                observer.complete();
            };

            // if failed
            fileReader.onerror = (error) => {
                observer.error(error);
            };
        });
    }

    readEmailAttachmentFiles(files: File[]): Observable<EmailAttachmentRawDto[]> {
        return forkJoin([...files.map((file) => this.readEmailAttachmentFile(file))]);
    }
}
